export const ModalCode = {
    depositResponse: 'depositResponse',
    withdrawalBonusesThatCanExpire: 'withdrawalBonusesThatCanExpire',
    withdrawalShopResponse: 'withdrawalShopResponse',
    withdrawalOnlineResponse: 'withdrawalOnlineResponse',
    withdrawalError: 'withdrawalError',
    depositError: 'depositError',
    qrDeposit: 'qrDeposit',
    depositRequiredBeforeWithdrawal: 'depositRequiredBeforeWithdrawal',
    depositResult: 'depositResult',
    sdsTransactionStatus: 'sdsTransactionStatus',
    addBankAccount: 'addBankAccount',
    addBankSuccess: 'addBankSuccess',
    removeBankAccount: 'removeBankAccount',
    cashierResult: 'cashierResult',
    withdrawalBalance: 'withdrawalBalance',
    quickDeposit: 'quickDeposit',
} as const;

export type ModalCode = typeof ModalCode[keyof typeof ModalCode];
